const { is } = require('stdlib/is')

/**
 * A megadott érték dátum?
 * @param {unknown} value - Az ismeretlen érték.
 * @returns {boolean} Érvényes dátum?
 */
module.exports.isValidDate = function isValidDate (value) {
  if (
    !is.string(value) &&
    !is.number(value) &&
    !is.instanceOf(value, Date)
  ) {
    return false
  }

  const d = new Date(value)

  const isValid = is.number(d.getTime())

  return isValid
}
